/**
 * General enums required
 */

export const DiagramTypes = {
    erDiagram: "erDiagram",
    relationalDiagram: "relationalDiagram"
}

export const ConnectionType = {
    association: "Association",
    inheritor: "Inheritor",
    parent:"Parent",
    attributeConnector: "AttributeConnector"
}